import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import Plyr from 'plyr';
import Player from '@vimeo/player';
import YT from 'youtube-player';
import { YouTubePlayer } from "youtube-player/dist/types";

@Component
export class ProductGallery extends ThemeComponent {
    @Prop background!: boolean;
    @Ref({required: false}) video!: HTMLVideoElement|HTMLIFrameElement|HTMLDivElement;
    @Ref({required: false}) trigger!: HTMLButtonElement;
    @Ref({required: false}) close!: HTMLButtonElement;
    @Ref({required: false}) popup!: HTMLDivElement;

    private player!: Plyr;

    init() {
        if (!this.video) { return; }
        this.player = new Plyr(this.video);
        this.setEventListeners();
    }

    /**
     * Set event listeners.
     */
    private setEventListeners() {
        if (!this.trigger) { return; }

        this.$listen(this.trigger, 'click', () => {
            this.handlePopup();

            document.body.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    this.handleClose();
                }
            });
        });

        this.$listen(this.close, 'click', () => {
            this.handleClose();
        });
    }

    /**
     * Handle video popup open.
     */
    private handlePopup() {
        this.popup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        this.player.togglePlay();
    }

    /**
     * Handle video popup close.
     */
    private handleClose() {
        this.popup.classList.remove('is-active');
        document.body.style.overflow = 'auto';
        this.player.pause();
    }
}
